export const metamaskSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 204.8 192.4"
    width="100%"
    height="100%"
    role="img"
    aria-hidden="true"
  >
    <title>MetaMask Logo</title>
    <path
      id="MM_Head_background__x28_Do_not_edit_x29_"
      d="m167.4 96.1 6.9-8.1-3-2.2 4.8-4.4-3.7-2.8 4.8-3.6-3.1-2.4 5-24.4-7.6-22.6m0 0-48.8 18.1H82L33.2 25.6l.3.2-.3-.2-7.6 22.6 5.1 24.4-3.2 2.4 4.9 3.6-3.7 2.8 4.8 4.4-3 2.2 6.9 8.1-10.5 32.4 9.7 33.1 34.1-9.4v-.1.1l6.6 5.4 13.5 9.2h23.1l13.5-9.2 6.6-5.4 34.2 9.4 9.8-33.1-10.6-32.4m-96.7 56"
      fill="#f5841f"
    />
    <g id="Logos">
      <path
        d="m171.5 25.6-59.9 44.1 11.1-26zM33.2 25.6l59.4 44.5L82 43.7zM150 127.9l-16 24.2 34.2 9.4 9.8-33.1zM26.9 128.4l9.7 33.1 34.1-9.4-15.9-24.2z"
        fill="#e27625"
      />
      <path
        d="m68.9 86.9-9.5 14.3 33.8 1.5-1.1-36.2zM135.9 86.9l-23.6-20.8-.7 36.6 33.8-1.5zM70.7 152.1l20.5-9.8-17.7-13.6zM113.6 142.3l20.4 9.8-2.8-23.4z"
        fill="#e27625"
      />
      <path
        d="m134 152.1-20.4-9.8 1.7 13.2-.2 5.6zM70.7 152.1l19 9-.1-5.6 1.6-13.2z"
        fill="#d7c1b3"
      />
      <path
        d="M90 119.9 73.1 115l12-5.5zM114.7 119.9l5-10.4 12 5.5z"
        fill="#2f343b"
      />
      <path
        d="m70.7 152.1 3-24.2-18.9.5zM131.1 127.9l2.9 24.2 16-23.7zM145.4 101.2l-33.8 1.5 3.1 17.2 5-10.4 12 5.5zM73.1 115l12-5.5 4.9 10.4 3.2-17.2-33.8-1.5z"
        fill="#cc6228"
      />
      <path
        d="m59.4 101.2 14.1 27.5-.4-13.7zM131.7 115l-.5 13.7 14.2-27.5zM93.2 102.7 90 119.9l4 20.4.9-26.8zM111.6 102.7l-1.7 10.7.8 26.9 4-20.4z"
        fill="#e27625"
      />
      <path
        d="m114.7 119.9-4 20.4 2.9 2 17.6-13.6.5-13.7zM73.1 115l.4 13.7 17.7 13.6 2.8-2-4-20.4z"
        fill="#f5841f"
      />
      <path
        d="m115.1 161.1.2-5.6-1.6-1.3H91l-1.4 1.3.1 5.6-19-9 6.6 5.4 13.5 9.3h23.1l13.5-9.3 6.6-5.4z"
        style={{
          fill: '#c0ad9e',
        }}
      />
      <path
        d="m113.6 142.3-2.9-2H94l-2.8 2-1.6 13.2 1.4-1.3h22.7l1.6 1.3z"
        fill="#2f343b"
      />
      <path
        d="m174.1 72.6 5-24.4-7.6-22.6-57.9 42.6 22.3 18.7 31.5 9.2 6.9-8.1-3-2.2 4.8-4.3-3.7-2.9 4.8-3.6zM25.6 48.2l5.1 24.4-3.2 2.4 4.8 3.7-3.7 2.8 4.8 4.3-3 2.2 7 8.1 31.5-9.2 22.3-18.7-58-42.6z"
        fill="#763e1a"
      />
      <path
        d="m167.4 96.1-31.5-9.2 9.5 14.3-14.2 27.5 18.8-.3h28zM68.9 86.9l-31.5 9.2-10.5 32.3h27.9l18.7.3-14.1-27.5zM111.6 102.7l2-34.5 9.1-24.5H82l9.2 24.5 2 34.5.8 10.8v26.8h16.7l.1-26.8z"
        fill="#f5841f"
      />
    </g>
  </svg>
);
